// extracted by mini-css-extract-plugin
module.exports = {"image-wrapper":"PageLinkImage_image-wrapper__oaQa3","image":"PageLinkImage_image__NE_W8"};